import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiCall } from '../AuthContext';
import { Layers, CheckCircle } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiCall('/api/auth/forgot-password', { method: 'POST', data: { email } });
      setSent(true);
    } catch {} finally { setLoading(false); }
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <div className="w-8 h-8 rounded-lg overflow-hidden flex items-center justify-center">
            <img src="/logo.png" alt="XLabelSync" className="w-8 h-8 object-cover" />
          </div>
          <span className="font-bold text-lg text-[#0F172A]">XLabelSync</span>
        </Link>
        {sent ? (
          <div className="text-center">
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-[#0F172A] mb-2">Check your email</h2>
            <p className="text-sm text-slate-500">If this email exists, a reset link has been sent.</p>
            <Link to="/login" className="inline-block mt-4 text-[#0052FF] text-sm font-medium">Back to login</Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-[#0F172A] mb-1">Forgot password?</h1>
            <p className="text-sm text-slate-500 mb-6">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-[#0052FF] focus:border-transparent transition-all outline-none text-sm"
                placeholder="you@example.com" data-testid="forgot-email" />
              <button type="submit" disabled={loading} data-testid="forgot-submit"
                className="w-full bg-[#0052FF] hover:bg-[#0040CC] text-white font-medium rounded-lg py-2.5 text-sm transition-colors disabled:opacity-50">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <Link to="/login" className="block mt-4 text-center text-sm text-[#0052FF] font-medium">Back to login</Link>
          </>
        )}
      </div>
    </div>
  );
}
